import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/ask/comment.png';
import _imports_1 from '@/assets/componentImg/ask/liked.png';
import _imports_2 from '@/assets/componentImg/ask/like.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-75eacf9e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "cell",
  style: {
    "{\r\n        'border-bottom'": "islast?'0': '9px solid #f7f7f8'"
  }
};
var _hoisted_2 = {
  class: "bottom-wrap"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: ""
};
var _hoisted_5 = {
  key: 1,
  src: _imports_2,
  alt: ""
};
import contentWrap from './content-wrap.vue';
import composition from '@/composition';
import LikeBtn from '@/components/common/like-btn.vue';
export default {
  props: {
    item: Object,
    isLast: Boolean
  },
  setup: function setup(__props) {
    var props = __props;

    var _composition = composition(),
        openWebPage = _composition.openWebPage;

    var openDetail = function openDetail() {
      openWebPage('ask.html', props.item.id);
    };

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        onClick: openDetail
      }, [_createVNode(contentWrap, {
        item: __props.item,
        type: "0"
      }, null, 8, ["item"]), _createVNode(contentWrap, {
        item: __props.item,
        type: "1"
      }, null, 8, ["item"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "comment-btn",
        onClick: openDetail
      }, "写下您的评论"), _createElementVNode("div", {
        class: "btn",
        onClick: openDetail
      }, [_hoisted_3, _createTextVNode(" " + _toDisplayString(__props.item.commentCount), 1)]), _createVNode(LikeBtn, {
        class: "btn",
        item: __props.item
      }, {
        main: _withCtx(function (_ref) {
          var record = _ref.record;
          return [record.loveState ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : (_openBlock(), _createElementBlock("img", _hoisted_5)), _createElementVNode("span", {
            style: _normalizeStyle({
              color: record.loveState ? '#FF2D3C' : '#666'
            })
          }, _toDisplayString(record.loveCount == 0 ? '点赞' : record.loveCount), 5)];
        }),
        _: 1
      }, 8, ["item"])])]);
    };
  }
};